<template>
  <div>
    <v-data-table
      :headers="headers"
      :items="grupos.content"
      class="elevation-1 mt-5 rounded-card"
      :loading="loading"
      :server-items-length="grupos.total"
      @update:options="updateOptions"
      :footer-props="footerOptions"
      no-data-text="Nenhuma categoria encontrada"
      loading-text="Carregando categorias..."
      :options="optionsList"
    >
      <template v-slot:item.codigo="{ item }">
        {{ item.codigo | naoInformado }}
      </template>
      <template v-slot:item.grupoPai.descricao="{ item }">
        {{ labelCategoriaPai(item) }}
      </template>
      <template v-slot:item.ativo="{ item }">
        <px-ativo :ativo="item.ativo"/>
      </template>
      <template v-slot:item.options="{ item }" v-if="hasRoleCadastroProduto">
        <v-btn icon
               @click="goToEditGrupo(item)">
          <v-icon>mdi-pencil</v-icon>
        </v-btn>
        <v-btn icon
               @click="onClickDelete(item)">
          <v-icon>mdi-delete</v-icon>
        </v-btn>
      </template>
    </v-data-table>
    <px-confirm-dialog ref="confirm"/>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
  props: {
    grupos: Object,
    default: [],
    loading: Boolean,
    onChangeOptions: {
      type: Function,
      required: true,
    },
    optionsList: Object,
    footerOptions: Object,
  },
  data() {
    return {
      headers: [
        {
          text: 'Código',
          value: 'codigo',
        },
        {
          text: 'Categoria',
          value: 'descricao',
        },
        {
          text: 'Categoria pai',
          value: 'grupoPai.descricao',
        },
        {
          text: 'Situação',
          value: 'ativo',
        },
        {
          text: null,
          sortable: false,
          value: 'options',
        },
      ],
    };
  },
  computed: {
    ...mapGetters('user', ['hasRoleCadastroProduto']),
    labelCategoriaPai() {
      return item => (item.grupoPai ? item.grupoPai.descricao : 'Não informada');
    },
  },
  methods: {
    updateOptions(options) {
      this.onChangeOptions(options);
    },
    remove(item) {
      this.$emit('remove', item);
    },
    goToEditGrupo(item) {
      this.$router.push({
        name: 'main.grupos.edicao',
        params: {
          id: item.id,
        },
      });
    },
    onClickDelete(item) {
      this.$refs.confirm.open('Você deseja remover este grupo?',
        'O grupo será removido e esta operação não pode ser desfeita.',
        { width: 450 })
        .then((confirm) => {
          if (!confirm) {
            return;
          }
          this.remove(item);
        });
    },
  },
};
</script>
